import React, { useState, useEffect } from 'react';
import { IonContent, IonText, IonButton, IonInput } from '@ionic/react';

// Note images mapping
const noteImages: Record<string, string> = {
    '₹1': '/assets/coins/1_rupee.png',
    '₹2': '/assets/coins/2_rupee.png',
    '₹5': '/assets/coins/5_rupee.png',
    '₹10': '/assets/coins/10_rupee.png',
    '₹20': '/assets/coins/20_rupee.png',
    '₹50': '/assets/coins/50_rupee.png',
    '₹100': '/assets/coins/100_rupee.png',
}

// Generate a random note question
const generateRandomNoteQuestion = () => {
    const notes = Object.keys(noteImages);
    const randomNote = notes[Math.floor(Math.random() * notes.length)]; // Select a random note
    return randomNote;
};

const IdentifyingMoney: React.FC = () => {
    const [currentNote, setCurrentNote] = useState<string>('');
    const [userAnswer, setUserAnswer] = useState<string>('');
    const [resultMessage, setResultMessage] = useState<string>('');
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        generateNewQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Money - Identifying"; // Set page title
    }, []);

    const generateNewQuestion = () => {
        const newNote = generateRandomNoteQuestion();
        setCurrentNote(newNote);
        setUserAnswer('');
        setResultMessage('');
        setIsCorrect(null);
    };

    const handleSubmit = () => {
        const correctValue = parseInt(currentNote.replace('₹', ''), 10);
        const userValue = parseInt(userAnswer, 10);

        if (userValue === correctValue) {
            setShowImage(true);
            setTimeout(() => {
                generateNewQuestion();
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

    return (
        <>

            {
                showImage === false ?
                <>
                    <div className='contentPart showCenter additionWord MoneyDiv'>
                        <div style={{ padding: '20px' }}>
                            <IonText>
                                <p>Identify the value of this note:</p>
                            </IonText>

                            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                            {currentNote && (
                                <img
                                src={noteImages[currentNote]}
                                alt={currentNote}
                                style={{
                                    width: '150px',
                                    height: '100px',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                    padding: '5px',
                                }}
                                />
                            )}
                            </div>

                            <div className='optionDiv mb-4' style={{ marginTop: '20px' }}>
                                <input
                                    type="number"
                                    value={userAnswer}
                                    onChange={(e) => setUserAnswer(e.target.value)}
                                    placeholder="Enter your answer (e.g., 50)"
                                    className={`form-control blank-input ${error == true  ? 'error' : ''} `}
                                />
                            </div>
                        
                            <div className='optionDiv text-center mt-2'> 
                                <div className='optionButton' onClick={handleSubmit}>
                                    Submit
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="contentPart showMiddle">
                        <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                    </div>
                </>
            }
        </>
    );
};

export default IdentifyingMoney;
